import React from 'react';
import _ from 'lodash';

import Box from '@mui/material/Box';

import { FiberManualRecordIcon } from '../customStyles/images';
import theme from '../../theme';

const PieChartLabel = ({ chartData, colors, label }) => {

  return (
    <Box
      sx={{
        display: 'flex',
        color: theme.palette.grey.w500,
        fontSize: 14,
        fontWeight: 400,
        flexWrap: 'wrap',
        flexDirection: 'row',
        minHeight: '8vh',
        maxHeight: '8vh'
      }}
    >
      {
        chartData && colors &&
        chartData.map((el, index) => {
          return (
            <Box
              key={`${el}-${index}`}
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <FiberManualRecordIcon style={{ color: colors[index % colors.length] }} /><span key={`${el}-${index}`}>{el[label]}</span>　　
            </Box>
          )
        })
      }
    </Box>
  )
}

export default PieChartLabel;